module.exports = __webpack_public_path__ + "static/media/24.bd7e7746.JPG";